// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__T9kUC","left":"InfoRow_left__1vMY3"};